module.exports = __webpack_public_path__ + "img/day14.5fb2acf0.jpeg";